import { Box, Button, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageRoot = styled(Box)({
    minHeight: '100vh',
    height: '100vh',
    overflowY: 'auto',
    backgroundColor: '#F7F6F4',
    display: 'flex',
    flexDirection: 'column',
});

export const HeaderBar = styled(Box)({
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E7EB',
    height: 72,
    display: 'flex',
    alignItems: 'center',
    padding: '0 40px',
    flexShrink: 0,
});

export const PageContent = styled(Box)({
    flex: 1,
    maxWidth: 960,
    margin: '0 auto',
    padding: '56px 24px 80px',
    width: '100%',
    boxSizing: 'border-box',
});

export const DownloadCardRoot = styled(Paper)(({ recommended }) => ({
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    border: recommended === 'true' ? '2px solid #2563EB' : '1.5px solid #E5E7EB',
    boxShadow: recommended === 'true'
        ? '0 4px 20px rgba(37,99,235,0.1)'
        : '0 1px 3px rgba(0,0,0,0.05)',
    padding: '28px 24px',
    paddingTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    flex: 1,
    minWidth: 0,
    position: 'relative',
}));

export const ReqCard = styled(Box)({
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    border: '1.5px solid #E5E7EB',
    padding: '22px 16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 10,
    height: '100%',
    boxSizing: 'border-box',
});

export const SectionCard = styled(Paper)({
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    border: '1.5px solid #E5E7EB',
    padding: '36px 32px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    marginBottom: 24,
});

export const PillTabsWrapper = styled(Box)({
    display: 'flex',
    gap: 8,
    marginBottom: 28,
    padding: '4px',
    backgroundColor: '#F3F4F6',
    borderRadius: 10,
    width: 'fit-content',
});

export const PillTab = styled(Button)(({ active }) => ({
    textTransform: 'none',
    fontWeight: active === 'true' ? 600 : 500,
    fontSize: '0.85rem',
    borderRadius: 7,
    padding: '7px 18px',
    minWidth: 0,
    backgroundColor: active === 'true' ? '#FFFFFF' : 'transparent',
    color: active === 'true' ? '#111827' : '#6B7280',
    boxShadow: active === 'true' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    '&:hover': {
        backgroundColor: active === 'true' ? '#FFFFFF' : 'rgba(0,0,0,0.04)',
    },
}));

export const StepRow = styled(Box)({
    display: 'flex',
    gap: 16,
    position: 'relative',
});

export const StepLeft = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    width: 32,
});

export const StepCircle = styled(Box)({
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: '#0F172A',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.8rem',
    fontWeight: 700,
    flexShrink: 0,
    zIndex: 1,
});

export const StepConnector = styled(Box)({
    width: 1,
    flex: 1,
    backgroundColor: '#E5E7EB',
    margin: '4px 0',
    minHeight: 12,
});

export const InfoBox = styled(Box)(({ variant }) => ({
    backgroundColor: variant === 'warning' ? '#FFFBEB' : '#EFF6FF',
    border: `1.5px solid ${variant === 'warning' ? '#FDE68A' : '#BFDBFE'}`,
    borderRadius: 10,
    padding: '14px 16px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    marginTop: 8,
}));

export const SupportCard = styled(Paper)({
    backgroundColor: '#0F172A',
    borderRadius: 16,
    padding: '36px 32px',
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 14,
});

export const PageFooterBar = styled(Box)({
    borderTop: '1px solid #E5E7EB',
    backgroundColor: '#FFFFFF',
    padding: '18px 24px',
    textAlign: 'center',
});
